import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import { lensPath } from 'ramda';

const unrelatedDocumentLens = lensPath(['data', 'unrelated_documents']);
export const unrelatedDocumentView = RA.viewOr([], unrelatedDocumentLens);
